<template>
  <div>
    <!-- Payment Registered -->
    <div v-if="paymentRegistered">
      <h5>Direktebetaling er registrert</h5>
      <p class="mt-4">
        <hl-Currency :amount="amountAsNumber" /> er registrert kontantbetalt <hl-Date :date="date" />. Hvis dette er
        feil kan en korrigering utføres i reskontro.
      </p>

      <div class="mt-5">
        <button class="btn btn-secondary ml-2" @click="goBackOnParent">Tilbake</button>
      </div>
    </div>
    <!-- / Payment Registered -->

    <!-- Payment not registered -->
    <div v-else>
      <h5>Registrer direktebetaling</h5>
      <p class="mt-4">
        Hvis hele eller deler av fakturaen er betalt direkte til utleiers bankkonto, evt. kontant, kan beløpet
        registreres som direktebetalt. Oppgi beløp og dato for betaling, og faktura og reskontro blir oppdatert.
      </p>
      <div class="mt-5 row">
        <div class="col">
          <span class="gray-color">Beløp som er direktebetalt</span>
          <hl-Input type="number" v-model="amount" />
        </div>
        <div class="col">
          <span class="gray-color">Beløpet ble betalt</span>
          <hl-Datepicker :disabled-dates="{ from: today }" v-model="date"></hl-Datepicker>
        </div>
      </div>

      <div class="mt-4">
        <hl-Button
          variant="primary"
          :disabled="!amount || !date || loading.registerPayment"
          class="mr-2"
          @click="registerPayment"
          :loading="loading.registerPayment"
          size="sm"
        >
          Register betaling
        </hl-Button>

        <hl-Button size="sm" variant="secondary" @click="goBackOnParent">Tilbake</hl-Button>
      </div>

      <hl-Alert v-if="errors" variant="danger">{{ errors }}</hl-Alert>
    </div>
    <!-- / Payment not registered -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';
import Datepicker from '@modules/husleie-framework/src/components/forms/inputs/Datepicker.vue';
import Alert from '@modules/husleie-framework/src/components/text/Alert.vue';
import Input from '@modules/husleie-framework/src/components/forms/inputs/input/Input.vue';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';
import Currency from '@modules/husleie-framework/src/components/currency/Currency.vue';

export default {
  components: {
    'hl-Button': Button,
    'hl-Alert': Alert,
    'hl-Datepicker': Datepicker,
    'hl-Input': Input,
    'hl-Date': Date,
    'hl-Currency': Currency,
  },

  props: ['landlordId', 'tenancyId', 'orderId'],

  data() {
    return {
      amount: null,
      date: null,
      paymentRegistered: false,
      errors: null,
      loading: {
        registerPayment: false,
      },
    };
  },

  computed: {
    today() {
      return moment().toDate();
    },
    amountAsNumber() {
      return parseFloat(this.amount);
    },
  },

  methods: {
    ...mapActions('tenancy', ['postTenancyDirectPayment']),

    async registerPayment() {
      this.loading.registerPayment = true;
      try {
        await this.postTenancyDirectPayment({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
          orderId: this.orderId,
          data: {
            amount: this.amount,
            date: this.date,
          },
        });
        this.paymentRegistered = true;
        this.$emit('newPayment');
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke lagre.', 'error');
      }
      this.loading.registerPayment = false;
    },

    goBackOnParent() {
      this.$emit('back');
    },
  },
};
</script>

<style lang="scss" scoped>
.gray-color {
  color: $gray-700;
}
</style>
